export default __webpack_public_path__ + "339b4571137d7244660c351b1328a6e7.mp3";